<template>
  <div :class="[{loading: show}, {loadinging: show}, type]">
    <div v-if="show" class="con">
      <div class="dot">
        <div></div><div></div><div></div><div></div><div></div>
      </div>
    </div>
    <!-- <slot v-show="!show">
    </slot> -->
    <div v-show="!show">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {type: Boolean, default: true},
    type: {type: String, default: 'body'}
  },
  created () {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  name: 'Loading',
  computed: {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style scoped>
.loading {
  width: 100%;
  height: 100%;
  display: flex;
}
.loadinging {
  align-items: center;
  justify-content: center;
}
.loading > div:last-child {
  width: 100%;
  height: 100%;
}
.loading .con {
  list-style: none;
  padding: 25px 0;
}
.loading .con > div {
    position: relative;
    width: 96px;
    height: 96px;
    margin: 0 auto;
    padding: 10px;
}
.popup {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup > div:last-child {
  display: flex;
  align-items: center;
}

.dot div {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    transform: translateY(-30px);
}

.dot div:nth-child(1) {
    width: 12px;
    height: 12px;
    border-radius: 10px;
    animation: dot 2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(2) {
    width: 10px;
    height: 10px;
    border-radius: 8px;
    animation: dot 2s 0.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(3) {
    width: 8px;
    height: 8px;
    border-radius: 6px;
    animation: dot 2s 0.2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(4) {
    width: 6px;
    height: 6px;
    border-radius: 4px;
    animation: dot 2s 0.3s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}

.dot div:nth-child(5) {
    width: 4px;
    height: 4px;
    border-radius: 2px;
    animation: dot 2s 0.4s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
}
.body .dot div {
  background-color: var(--text-base);
}
.popup .dot div {
  background-color: var(--bg-white);
}

.body > div {
  width: 100%;
  height: 100%;
}

@keyframes dot {
    0% {
        transform: rotate(0deg) translateY(-30px);
    }
    100% {
        transform: rotate(360deg) translateY(-30px);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/base/Loading.vue